/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useLocation } from 'react-router-dom'
import React, { useEffect } from 'react'

import history from '@modules/utils/history'

// eslint-disable-next-line import/no-restricted-paths
import UserConsoleAppLoadingRoot from '../../public/components/AppLoadingRoot/UserConsoleAppLoadingRoot'

import type { FunctionComponent } from 'react'

export function handleOnboardingRedirect({
  onboardingServiceType,
}: {
  onboardingServiceType: string | null | undefined
}): void {
  if (onboardingServiceType === 'ccm') {
    history.push(`/onboarding/ccm`)
    return
  }

  history.push(`/home`)
}

const RedirectServicesOnboarding: FunctionComponent = () => {
  const location = useLocation()

  const { search } = location

  const queryParams = new URLSearchParams(search)

  const onboardingServiceType = queryParams.get('onboarding_service_type')

  useEffect(() => {
    handleOnboardingRedirect({
      onboardingServiceType,
    })
  }, [onboardingServiceType])

  return <UserConsoleAppLoadingRoot />
}

export { RedirectServicesOnboarding }
